<div>
  <ng-container *ngIf="filterUsesSubtype()">
    <div class="space" *ngIf="subtypeDataOptions$ | async as subtypeDataOptions; else loading">
      <glxy-form-field>
        <mat-select [formControl]="subtypeOptionControl">
          <ng-container *ngFor="let option of subtypeDataOptions">
            <mat-option [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-error *ngIf="filterError$ | async as filterError">
          {{ filterError | translate }}
        </mat-error>
      </glxy-form-field>
    </div>
  </ng-container>
  <div class="space" *ngIf="filteredDataComponentOptions$ | async as dataComponentOptions; else loading">
    <glxy-form-field [disabled]="hasNoFilteredDataOptions()">
      <mat-select
        [formControl]="dataOptionControl"
        [placeholder]="hasNoFilteredDataOptions() ? noFilteredDataOptionsPlaceholder : ''"
      >
        <ng-container *ngFor="let option of dataComponentOptions">
          <mat-option [value]="option.value">
            {{ option.label | translate }}
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-error *ngIf="filterError$ | async as filterError">
        {{ filterError | translate }}
      </mat-error>
    </glxy-form-field>
  </div>
  <div
    [hidden]="hasNoFilteredDataOptions()"
    class="space"
    *ngIf="(selectedFilterComponent$ | async) && !resetComparisonSelect"
  >
    <ng-container *ngIf="comparisonOptions$ | async as comparisonOptions">
      <glxy-form-field>
        <mat-select [formControl]="comparisonOptionControl">
          <ng-container *ngFor="let option of comparisonOptions">
            <mat-option [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          </ng-container>
        </mat-select>
        <glxy-error *ngIf="filterError$ | async as filterError">
          {{ filterError | translate }}
        </glxy-error>
      </glxy-form-field>
    </ng-container>
  </div>
  <div [hidden]="hasNoFilteredDataOptions()">
    <ng-template automataDynamicComponent></ng-template>
  </div>
</div>

<ng-template #loading>
  <ng-container [ngSwitch]="hasError">
    <div *ngSwitchCase="false" class="content side-drawer-shimmer-container">
      <span class="control-container selector stencil-shimmer"></span>
      <span class="control-container selector stencil-shimmer"></span>
    </div>
    <div *ngSwitchCase="true" class="filter-load-error">
      {{ 'AUTOMATIONS.EDITOR.ERRORS.UNABLE_TO_LOAD_FILTER' | translate }}
    </div>
  </ng-container>
</ng-template>
